<div class="p-g-6 p-md-12">
  <div class="activity-box">
    <div class="p-g activity-header-area">
      <h4 class="activity-header">{{headerLHS}}</h4>
    </div>
    <div class="activity-body-area">
      <div class="p-g" *ngFor="let notifs of activityNotifications">
        <div class="p-g-11 p-md-10">
          <div class="activity-content">{{notifs.nitfication}}</div>
        </div>
        <div class="p-g-1 p-md-2">
          <div class="activity-time">{{notifs.time}}</div>
        </div>
      </div>
      <div class="p-g">
        <span class="show-all-notifs">View All</span>
      </div>
    </div>
  </div>
</div>

<div class="p-g-6 p-md-12">
  <div class="activity-box">
    <div class="p-g activity-header-area">
      <h4 class="activity-header">{{headerRHS}}</h4>
    </div>
    <div class="activity-body-area">
      <div class="p-g" *ngFor="let notifs of activityNotifications">
        <div class="p-g-11 activity-content">{{notifs.nitfication}}</div>
        <div class="p-g-1 activity-time">{{notifs.time}}</div>
      </div>
      <div class="p-g">
        <span class="show-all-notifs">View All</span>
      </div>
    </div>
  </div>
</div>
